import React from 'react';

const BlankSlateDescription = props => (
  <div className="NewBlankSlate-description c-midnight-70">
    {props.children}
  </div>
);

export default BlankSlateDescription;
